interface BlockquoteProps {
  quote?: string;
  author?: string;
  authorTitle?: string;
}

export function BlockquoteBlock({ props }: { props: BlockquoteProps }) {
  if (!props.quote) return null;

  return (
    <blockquote className="border-l-4 border-indigo-400 pl-6 py-2 my-4">
      {/* CMS admin-authored content — safe for innerHTML */}
      <div className="text-lg text-zinc-700 italic prose prose-zinc max-w-none" dangerouslySetInnerHTML={{ __html: props.quote }} />
      {props.author && (
        <footer className="mt-3 text-sm text-zinc-500">
          — <span className="font-medium text-zinc-700">{props.author}</span>
          {props.authorTitle && <span className="text-zinc-400">, {props.authorTitle}</span>}
        </footer>
      )}
    </blockquote>
  );
}
